<template>
  <div class="coverage">
    <div class="map-container">
      <!-- <coverage-map v-if="$route.name === 'Coverage'"></coverage-map> -->
      <coverage-map2></coverage-map2>
    </div>

    <div class="sector-list">
      <sector-list></sector-list>
    </div>
    <coverage-shift-form></coverage-shift-form>
  </div>
</template>

<script>
import CoverageMap from './Map'
import CoverageMap2 from './Map2'
import CoverageShiftForm from './ShiftForm'
import SectorList from './SectorList'
import ApiServices from '@/modules/api/services'

export default {
  name: 'coverage',
  components: { CoverageMap, CoverageMap2, CoverageShiftForm, SectorList },
  // components: { CoverageMap, CoverageShiftForm, SectorList },
  mounted () {
    let self = this


    let services = self.$store.state.services
    if (!services.list.length && !services.serviceLoading) {
      self.$store.commit('services/setServiceLoading', true)
      ApiServices.getAllService(self, r => {
        self.$store.commit('services/setServiceLoading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$map-width: 60%;
.coverage {
  position: absolute;
  height: 100%;
  width: 100%;
}

.map-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: $map-width;
}

.sector-list {
  position: absolute;
  top: 0;
  left: $map-width;
  height: 100%;
  width: calc(100% - (#{$map-width}));
  background-color: #F4F8F9;
  box-shadow: -2px 0 6px rgba(0,0,0,0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/Coverage/index.vue